<div class="container mt-5">

    <foehn-page-counter></foehn-page-counter>

    <foehn-form>
        <div class="row">
            <div class="col-md-8">
                <foehn-input-nav13
                    [(model)]="form.informationApplicant.avs"
                    [helpText]="'information-applicant.avs.helpText' | fromDictionary"
                    [label]="'information-applicant.avs.label' | fromDictionary"
                    name="informationApplicant.avs"
                    required="true"
                >
                </foehn-input-nav13>

                <foehn-select
                    [(model)]="form.informationApplicant.civility"
                    [elementValue]="wholeValue"
                    [elements]="civilities"
                    [label]="'information-applicant.civility.label' | fromDictionary"
                    elementLabel="longDescription"
                    name="informationApplicant.civility"
                    required="true"
                >
                </foehn-select>

                <foehn-input-text
                    [(model)]="form.informationApplicant.lastName"
                    [disabled]="form.requestOrigin.isSelfRequest"
                    [label]="'information-applicant.lastName.label' | fromDictionary"
                    name="informationApplicant.lastName"
                    required="true"
                >
                </foehn-input-text>

                <foehn-input-text
                    [(model)]="form.informationApplicant.firstName"
                    [disabled]="form.requestOrigin.isSelfRequest"
                    [label]="'information-applicant.firstName.label' | fromDictionary"
                    name="informationApplicant.firstName"
                    required="true"
                >
                </foehn-input-text>

                <foehn-input-date
                    [(model)]="form.informationApplicant.birthDate"
                    [helpText]="'information-applicant.birthDate.helpText' | fromDictionary"
                    [labelStyleModifier]="'h3'"
                    [label]="'information-applicant.birthDate.label' | fromDictionary"
                    name="informationApplicant.birthDate"
                    required="true"
                >
                </foehn-input-date>

                <foehn-select
                    #foehnSelectNationality
                    [(model)]="form.informationApplicant.nationality"
                    [elementValue]="wholeValue"
                    [elements]="nationalities"
                    [label]="'information-applicant.nationality.label' | fromDictionary"
                    elementLabel="shortNameFr"
                    name="informationApplicant.nationality"
                    required="true"
                >
                </foehn-select>

                <foehn-input-number
                    [(model)]="form.informationApplicant.dateOfArrival"
                    [disabled]="isSwissNationalitySelected"
                    [label]="'information-applicant.dateOfArrival.label' | fromDictionary"
                    [required]="!isSwissNationalitySelected"
                    name="informationApplicant.dateOfArrival"
                >
                </foehn-input-number>

                <foehn-select
                    [(model)]="form.informationApplicant.residencePermit"
                    [disabled]="isSwissNationalitySelected"
                    [elementValue]="wholeValue"
                    [elements]="residencePermits"
                    [label]="'information-applicant.residencePermit.label' | fromDictionary"
                    [required]="!isSwissNationalitySelected"
                    elementLabel="valeur"
                    name="informationApplicant.residencePermit"
                >
                </foehn-select>

                <foehn-input-address
                    [(model)]="form.informationApplicant.address"
                    [countryRequired]="true"
                    [foreignLocalityRequired]="true"
                    [foreignStreetNumberRequired]="true"
                    [foreignStreetRequired]="true"
                    [foreignZipCodeRequired]="true"
                    [isOnlySwiss]="false"
                    [labelStyleModifier]="'h3'"
                    [label]="'information-applicant.address.label' | fromDictionary"
                    [showAdressLines]="false"
                    [streetNumberRequired]="true"
                    [streetRequired]="true"
                    [swissNpaLocalityRequired]="true"
                    name="informationApplicant.address"
                    required="true"
                ></foehn-input-address>

                <foehn-input-text
                    [(model)]="form.informationApplicant.additionalAddress"
                    [label]="'information-applicant.additionalAddress.label' | fromDictionary"
                    name="informationApplicant.additionalAddress"
                ></foehn-input-text>

                <foehn-input-email
                    [(model)]="form.informationApplicant.email"
                    [disabled]="form.requestOrigin.isSelfRequest"
                    [helpText]="'information-applicant.email.helpText' | fromDictionary"
                    [label]="'information-applicant.email.label' | fromDictionary"
                    name="informationApplicant.email"
                    required="true"
                >
                </foehn-input-email>

                <foehn-input-phone
                    [(model)]="form.informationApplicant.phone"
                    [label]="'information-applicant.phone.label' | fromDictionary"
                    name="informationApplicant.phone"
                    required="true"
                ></foehn-input-phone>

                <foehn-select
                    [(model)]="form.informationApplicant.contactPreference"
                    [elementValue]="wholeValue"
                    [elements]="contactPreferences"
                    [label]="'information-applicant.contactPreference.label' | fromDictionary"
                    elementLabel="valeur"
                    name="informationApplicant.contactPreference"
                >
                </foehn-select>

                <foehn-navigation
                    (onNext)="send()"
                    (onPrevious)="previous()"
                    id="navigation"
                ></foehn-navigation>
            </div>


        </div>
    </foehn-form>
</div>
